// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"459016a8","323":"eb426e96","380":"e4109b75","527":"0c7c7b74","555":"b1eec991"}[chunkId] + ".chunk.css";
};